module.exports = __webpack_public_path__ + "static/media/eQ-logo.b82fa007.png";